export default function() {
    return {
        showScrollTop: false,
        scrollTopTimer: null
    }
}
